import { Result } from "../../../common-models/Result";
import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { GenerateInternalCommunicationsToCollectRecipeByOrderInput } from "./GenerateInternalCommunicationsToCollectRecipeByOrderInput";
import { GenerateInternalCommunicationsToCollectRecipeByOrderOutput } from "./GenerateInternalCommunicationsToCollectRecipeByOrderOutput";

export class GenerateInternalCommunicationsToCollectRecipeByOrderService extends HttpServiceBase {

  handle = (input: GenerateInternalCommunicationsToCollectRecipeByOrderInput): Promise<Result<GenerateInternalCommunicationsToCollectRecipeByOrderOutput> | null> => {
    const promise = this.http.post<Result<GenerateInternalCommunicationsToCollectRecipeByOrderOutput>,
      GenerateInternalCommunicationsToCollectRecipeByOrderInput>(
        `${this.baseUrlSislogApi}/v2/order/${input.orderId}/request-for-recipe-collection-notifications`, input);
    return promise;
  }
}